export default "__VITE_ASSET__DvgwoIdq__"